/**
 * @fileoverview GET handler for the "/engagement/report_dashboard/latest" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementReportDashboardLatest } from "./constants";
import type { EngagementReportDashboardLatestResult } from "./types";

export const getEngagementReportDashboardLatest = reactQueryFetcherAdapter(
  engagementReportDashboardLatest,
  (signal: AbortSignal): Promise<EngagementReportDashboardLatestResult> => {
    return fetch("/engagement/report_dashboard/latest", "GET", {}, { signal });
  }
);
